import { ContainerModule, interfaces } from 'inversify';
import { AnnotationService, IAnnotationService } from './annotation.service';
import { AnnotationApiService, IAnnotationApiService } from './annotationApi.service';
import { AnnotationCreationService, IAnnotationCreationService } from './annotationCreation.service';
import { AnnotationImagesQueueService, IAnnotationmagesQueueService } from './annotationImagesQueue.service';
import { AnnotationReviewService, IAnnotationReviewService } from './annotationReview.service';
import { AnnotationsStore, IAnnotationsStore } from './annotations.store';
import { AnnotationUiStore, IAnnotationUiStore } from './annotationUi.store';
import { FreeDrawSegmentationService, IFreeDrawSegmentationService } from './freeDrawSegmentation.service';
import { IReviewImagesQueueService, ReviewImagesQueueService } from './reviewImagesQueue.service';
import { IUndoRedoHistory, UndoRedoHistory } from './undoRedoHistory.service';
import { IUndoRedoHistoryQueue, UndoRedoHistoryQueue } from './undoRedoHistoryQueue.service';

export const annotationModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IAnnotationApiService.$).to(AnnotationApiService).inSingletonScope();
  bind(IAnnotationUiStore.$).to(AnnotationUiStore).inSingletonScope();
  bind(IAnnotationReviewService.$).to(AnnotationReviewService).inSingletonScope();
  bind(IAnnotationService.$).to(AnnotationService).inSingletonScope();
  bind(IAnnotationCreationService.$).to(AnnotationCreationService).inSingletonScope();
  bind(IUndoRedoHistoryQueue.$).to(UndoRedoHistoryQueue).inSingletonScope();
  bind(IUndoRedoHistory.$).to(UndoRedoHistory).inSingletonScope();
  bind(IAnnotationmagesQueueService.$).to(AnnotationImagesQueueService).inTransientScope();
  bind(IReviewImagesQueueService.$).to(ReviewImagesQueueService).inTransientScope();
  bind(IFreeDrawSegmentationService.$).to(FreeDrawSegmentationService).inSingletonScope();
  bind(IAnnotationsStore.$).to(AnnotationsStore).inSingletonScope();
});
